
import { motion } from 'framer-motion';
import { Plus, ArrowRight, User, MessageSquare, StickyNote, AlertTriangle, Clock, XCircle, CircleCheck } from 'lucide-react';
import moment from 'moment';
import { useState } from 'react';
import { useSupportTicketActivity } from '../../../../composables/support-ticket/useSupportTicketActivity';


const iconMap: Record<any['type'], typeof Plus> = {
  created: Plus,
  status_changed: ArrowRight,
  assigned: User,
  reply: MessageSquare,
  note: StickyNote,
  priority_changed: AlertTriangle,
  escalated: AlertTriangle,
  closed: CircleCheck
};

const colorMap: Record<any['type'], string> = {
  created: 'bg-primary/10 text-primary',
  status_changed: 'bg-yellow-100 text-yellow-700',
  assigned: 'bg-indigo-100 text-indigo-700',
  reply: 'bg-green-100 text-green-700',
  note: 'bg-gray-100 text-gray-600',
  priority_changed: 'bg-red-100 text-red-700',
  escalated: 'bg-red-100 text-red-700',
  closed: 'bg-gray-100 text-gray-700'
};

const Timeline = ({ code }: { code: string }) => {
  const [page, setCurrentPage] = useState<number>(1);

  const { data: activities } = useSupportTicketActivity({
    page,
    code
  });

  return (
    <div className="box-shadow rounded-2xl border border-gray-200 p-5">
      <h3 className="text-sm font-semibold text-foreground mb-4 flex items-center gap-2">
        <Clock className="h-4 w-4 text-muted-foreground" />
        Activity Timeline
      </h3>
      <div className="max-h-[400px] overflow-y-auto pr-1 space-y-0">
        {activities?.items?.map((activity: any, i: number) => {
          const Icon = iconMap[activity.event];
          return (
            <motion.div
              key={activity.event}
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.05 }}
              className="relative flex gap-3 pb-4 last:pb-0"
            >
              {/* Line */}
              {i < activities?.items?.length - 1 && (
                <div className="absolute left-[15px] top-8 bottom-0 w-px bg-[#e5e7eb]" />
              )}
              {/* Icon */}
              <div className={`relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${colorMap[activity.event]}`}>
                <Icon className="h-3.5 w-3.5" />
              </div>
              {/* Content */}
              <div className="min-w-0 pt-0.5">
                <p className="text-sm font-medium text-foreground capitalize">{activity.subject}</p>
                <p className="text-xs text-muted-foreground mt-0.5 text-gray-500">{activity.description}</p>
                <div className="flex items-center gap-2 mt-1 themeTextMuted">
                  <span className="text-[11px] text-muted-foreground">{activity.performed_by}</span>
                  <span className="text-[11px] text-muted-foreground">•</span>
                  <span className="text-[11px] text-muted-foreground">
                    {moment(activity.created_at).format('lll')}
                  </span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Timeline;
